import {
    Autocomplete,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "src/stateManagement/redux";

export const projects = [
    {
        id: "LB",
        label: "Bachaquero Tierra",
        projectId: "e8de6828-b7db-11ef-bebc-22937bb103f9",
    },
    {
        id: "LS",
        label: "Lagunillas Tierra",
        projectId: "e6c51ece-b7db-11ef-bebc-22937bb103f9",
    },
];

const types = [
    {
        id: "Optimization",
        label: "Optimización",
    },
];

const status = [
    {
        id: "Pending",
        label: "Pendiente",
    },
    {
        id: "inProgress",
        label: "En Progreso",
    },
    {
        id: "analyzing",
        label: "Analizando",
    },
    {
        id: "completed",
        label: "Completado",
    },
    {
        id: "discarded",
        label: "Descartado",
    },
    {
        id: "blocked",
        label: "Bloqueado",
    },
];

interface Props {
    TabDisable: boolean;
    formValues: any;
    handleInputChange: any;
    elementsWithErrors: string[];
}

interface ListOfActivities {
    id: string;
    label: string;
}

export const HeaderAddActivity = ({
    TabDisable,
    formValues,
    handleInputChange,
    elementsWithErrors
}: Props) => {
    const { field, locationName, fieldActivities } = useSelector((state) => state.location);

    const { users } = useSelector((state) => state.gerenciaTecnica);

    const { requiredUserId, originFieldActivityId } = formValues;

    const [listOfFieldActivities, setListOfFieldActivities] = useState<ListOfActivities[]>([])

    useEffect(() => {
        const ListOfActivities = fieldActivities.map((activity: any) => {
            const variables = activity?.variables?.find((variable: any) => variable.id === "6d7ad753-bb56-479a-ac5c-d26039113564");
            const executedDate = activity?.executedDate;
            const typeOfActivity = activity?.typeOfActivity;
            const executedBy = activity?.executedBy;

            return {
                id: activity.fieldActivityId,
                label: `${moment(executedDate).format('DD-MM-YYYY')} - ${typeOfActivity} - ${executedBy}`
            }
        })

        if (Array.isArray(ListOfActivities)) {
            setListOfFieldActivities(ListOfActivities)
        }

    }, [fieldActivities])


    return (
        <Grid sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
        }}>
            <Grid sx={{ width: 200 }}>
                <TextField
                    fullWidth
                    size="medium"
                    label="Campo"
                    value={field}
                    disabled
                    onChange={(e) => { }}
                />
            </Grid>
            <Grid sx={{ width: 200 }}>
                <TextField
                    fullWidth
                    size="medium"
                    label="Locación"
                    value={locationName}
                    disabled
                    onChange={(e) => { }}
                />
            </Grid>
            <Grid sx={{ width: 200 }}>
                <FormControl fullWidth error={elementsWithErrors.includes("requiredUserId")}>
                    <InputLabel id="demo-simple-select-label">
                        Requerido por
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={requiredUserId}
                        name="requiredUserId"
                        label="Requerido por"
                        fullWidth
                        onChange={handleInputChange}
                    >
                        {users!.map((user: any, index: number) => (
                            <MenuItem value={user.id} key={index}>
                                {user.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid sx={{ width: 200 }}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={types[0].id}
                        name="type"
                        label="Tipo"
                        fullWidth
                        onChange={handleInputChange}
                    >
                        {types!.map((type: any, index: number) => (
                            <MenuItem value={type.id} key={index}>
                                {type.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid sx={{ width: 200 }}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                        Status
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={status[0].id}
                        name="status"
                        label="Status"
                        fullWidth
                        onChange={handleInputChange}
                        disabled={TabDisable}
                    >
                        {status!.map((status: any, index: number) => (
                            <MenuItem value={status.id} key={index}>
                                {status.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid sx={{ width: 200 }}>
                <DesktopDatePicker
                    defaultValue={moment()}
                    label="Fecha Requerida"
                    disabled={TabDisable}
                    sx={{
                        width: "100%",
                    }}
                />
            </Grid>
            <Grid sx={{ width: 420 }}>
                <FormControl fullWidth error={elementsWithErrors.includes("originFieldActivityId")}>
                    <Autocomplete
                        disablePortal
                        options={listOfFieldActivities}
                        value={listOfFieldActivities.find(x=>x.id===originFieldActivityId)||null}
                        renderInput={(params) => <TextField {...params} label="Actividad Asociada" name="originFieldActivityId" />}
                        sx={{
                            border: elementsWithErrors.includes("originFieldActivityId") ? "1px solid red":"none",
                        }}
                        onChange={(event, newValue) => {
                            handleInputChange({
                                target: {
                                    name: "originFieldActivityId",
                                    value: newValue?.id,
                                }
                            });
                        }}
                    />
                </FormControl>
            </Grid>
        </Grid>
    );
};
